import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { RevShareQueriesConfig } from './rev-share.config';
import { RevShareApiClientContext } from './rev-share.context';
export const RevShareApiClient = {
  ...createApiClient(RevShareQueriesConfig),
  context: RevShareApiClientContext
};
//# sourceMappingURL=rev-share.api-client.js.map